/// <amd-module name="Wit/WorkItemModel/Services/IWorkItemModelService" />
import { IVssService } from "VSS/Platform/Context";
import { QueryErrorPolicy } from "Wit/Clients/Wit/Contracts/WorkItemTracking";
import { IFieldLookup, IFieldProjectData, IWorkItemData, IWorkItemTypeData } from "Wit/WorkItemDataManager/Contracts";
import { IWorkItem, IWorkItemTypeExtension } from "Wit/WorkItemModel/OM/WorkItemInterfaces";

export interface IWorkItemModelService extends IVssService {
    addWorkItemToMap(id: number, workItem: IWorkItem): void;
    clearWorkItems(): void;
    clearWorkItem(id: number): void;
    createWorkItem(typeData: IWorkItemTypeData, projectid: string, data?: Partial<IWorkItemData>): Promise<IWorkItem>;
    getConstantSets(ids: string[]): Promise<{ [key: string]: string[] }>;
    getWorkItems(
        ids: number[],
        isDeleted?: boolean,
        includeRecentActivity?: boolean,
        includeHistory?: boolean,
        isCacheDisabled?: boolean,
        errorPolicy?: QueryErrorPolicy
    ): Promise<IWorkItem[]>;
    getWorkItem(id: number, config?: { isDeleted?: boolean, includeRecentActivity?: boolean, includeHistory?: boolean }): Promise<IWorkItem>;
    getWorkItemTypeData(projectId: string, workItemTypeNames: string[]): Promise<IWorkItemTypeData[] | null>;
    getFieldProjectData(projectId: string): Promise<IFieldProjectData | null>;
    getFieldLookup(projectId: string): Promise<IFieldLookup | null>;
    getTagsMRU(): Promise<string[]>;
    addTagsMru(newTags: string[]): Promise<void>;
    getWorkItemTypeExtensions(extensionIds: string[]): Promise<IWorkItemTypeExtension[]>;
    isWorkItemCached(id: number): boolean;
    refreshWorkItemLinks(workItem: IWorkItem): Promise<void>;
}
